import { NoteLib, ScaleLib } from '@tunasong/music-lib'
import type { NoteOctave } from '@tunasong/music-lib'
import type { NoteName, Scale } from '@tunasong/schemas'
import type { CSSProperties, FC, HTMLAttributes } from 'react'
import { NoteDegree } from './note-degree.js'

export interface NoteProps extends HTMLAttributes<HTMLSpanElement> {
  note: NoteName | NoteOctave
  scale?: Scale | null
}

export const Note: FC<NoteProps> = props => {
  const { note: providedNote, scale, style: styleProp, ...restProps } = props
  const note = NoteLib.toNote(providedNote)

  const inScale = scale ? ScaleLib.noteInScale(scale, note) : true
  const scaleNote = scale ? ScaleLib.getScaleNoteName(scale, note) : note
  const niceNote = NoteLib.prettifyNote(scaleNote)
  const interval = scale ? ScaleLib.getInterval(scale, note) : null

  const noteColor = scale
    ? inScale
      ? 'var(--tuna-notes-inScale)'
      : 'var(--tuna-notes-outOfScale)'
    : 'inherit'

  const style: CSSProperties = {
    position: 'relative',
    alignSelf: 'center',
    color: noteColor,
    display: 'inline-flex',
    ...styleProp,
  }

  return (
    <span
      contentEditable={false}
      style={style}
      {...restProps}
    >
      {niceNote}
      {interval ? <NoteDegree degree={interval} style={styleProp} /> : null}
    </span>
  )
}
